import { Component, OnInit } from '@angular/core';
import { UserModeService } from 'src/app/services/customs/user-mode/user-mode.service';

@Component({
  selector: 'app-financials',
  templateUrl: './financials.component.html',
  styleUrl: './financials.component.scss'
})
export class FinancialsComponent implements OnInit {
  currentUserMode: any = 'customer';
  constructor(private userModeService: UserModeService) { }

  ngOnInit(): void {
    this.userModeService.mode$.subscribe((mode) => {
      if (!mode) return; // no user yet

      this.currentUserMode = mode;
    });
  }


}
